import { onBeforeMount, reactive, computed, ref } from "@vue/composition-api";
import documentModel from "@/models/document/document";
import router from "@/router";
import store from "@/store";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";

export default function useDashboardDetail() {
  const { fetchDocumentBi } = documentModel();
  const { openDefaultErrorModal } = useValidationModal();
  const dataList = reactive({
    summary: { payload: [{},{},{},{}] },
    statusDocument: { payload: [] },
    admin: { payload: [] },
  });
  const loadingMiniDashboard = ref(false);

  const DEFAULT_ICON_DYNAMIC = {
    Customer:
      "https://media.discordapp.net/attachments/887366626561904641/940836626702147594/Group_28226.png",
    Document:
      "https://media.discordapp.net/attachments/887366626561904641/940836626152714271/Group_28079.png",
    Other:
      "https://media.discordapp.net/attachments/887366626561904641/940836625871683634/Group_28078.png",
  };

  const getDocumentBiList = () => {
    loadingMiniDashboard.value = true;
    fetchDocumentBi.payload.Container_Id = router.currentRoute.params.ref;
    store
      .dispatch("api/apiRequest", fetchDocumentBi)
      .then((response) => {
        dataList.summary.payload = []
        const resp = response.data.data;
        dataList.admin.payload = resp.admin;
        dataList.statusDocument.payload = resp.status_document;
        resp.dynamic_overall.map((o) => {
          dataList.summary.payload.push({
            image_url:DEFAULT_ICON_DYNAMIC[o.label] || DEFAULT_ICON_DYNAMIC.Other,
            name: o.label,
            score: o.value,
          });
        });
      })
      .catch((error) => {
        openDefaultErrorModal(error);
      })
      .finally(() => {
        loadingMiniDashboard.value = false;
      });
  };

  const renderLayoutDynamicOverall = computed(() => {
    if(dataList.summary.payload.length < 3){
      return "w-summary-100"
    } else if(dataList.summary.payload.length > 4){
      return "w-summary-16"
    } else {
      return "w-summary-50"
    }
  })

  const resolveLengthDynamicOverall = computed(() => {
    return dataList.summary.payload.length > 4
  })

  onBeforeMount(() => {
    getDocumentBiList();
  });

  return {
    dataList,
    loadingMiniDashboard,
    renderLayoutDynamicOverall,
    resolveLengthDynamicOverall
  };
}
